import React, { useState, useEffect } from 'react'
import { Carousel } from 'react-bootstrap'
import Star from 'elements/Star'

export default function Testimony({ data }) {
    const [isMobile, setIsMobile] = useState(false)

    // Deteksi ukuran layar
    useEffect(() => {
        const handleResize = () => setIsMobile(window.innerWidth <= 768)
        handleResize()
        window.addEventListener('resize', handleResize)
        return () => window.removeEventListener('resize', handleResize)
    }, [])

    // Jika mobile → 1 item per slide, jika desktop → 2 item per slide
    const chunkSize = isMobile ? 1 : 2

    const chunkedData = data
        .map((_, index) =>
            index % chunkSize === 0 ? data.slice(index, index + chunkSize) : null
        )
        .filter(chunk => chunk !== null)

    return (
        <section style={{ backgroundColor: "rgba(105, 105, 105, 0.05)" }}>
            <div className="container pb-5">
                <div className="row text-center justify-content-center" style={{ color: "#696969" }}>
                    <div className="col-lg-8 col-md-10 col-12 my-5">
                        <h2 style={{ color: "#333333" }}>
                            Testimoni dari Pengunjung Green Hill Kemuning
                        </h2>
                        <p className="lead" style={{ fontSize: "1rem" }}>
                            Mari dengarkan cerita para pengunjung tentang pengalaman mereka menyewa villa dan venue event di Green Hill Kemuning
                        </p>
                    </div>
                </div>

                <div className="row justify-content-center">
                    <Carousel interval={5000}>
                        {chunkedData.map((chunk, index) => (
                            <Carousel.Item key={index}>
                                <div className="row justify-content-center mb-5">
                                    {chunk.map((testimonial, subIndex) => (
                                        <div
                                            key={subIndex}
                                            className="card m-2 p-2"
                                            style={{
                                                width: isMobile ? '90%' : '45%',
                                                maxWidth: '500px',
                                                border: 'none',
                                                borderRadius: '10px',
                                                boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
                                            }}
                                        >
                                            <div className={`d-flex ${isMobile ? 'flex-column align-items-center text-center' : ''}`}>
                                                <img
                                                    src={`${process.env.REACT_APP_HOST}/images/${testimonial.imageUrl}`}
                                                    alt="Testimonial"
                                                    className="card-img-top"
                                                    style={{
                                                        width: isMobile ? '60%' : '30%',
                                                        height: 'auto',
                                                        objectFit: 'cover',
                                                        borderRadius: '10px',
                                                        padding: isMobile ? '10px' : '10px 0',
                                                    }}
                                                />
                                                <div
                                                    className="card-body"
                                                    style={{
                                                        width: isMobile ? '100%' : '70%',
                                                        color: "#696969"
                                                    }}
                                                >
                                                    <p
                                                        className="fw-bold"
                                                        style={{
                                                            marginBottom: isMobile ? 10 : 80,
                                                            marginTop: 20,
                                                            color: "#333333"
                                                        }}
                                                    >
                                                        {testimonial.name}
                                                    </p>
                                                    <div className={`${isMobile ? 'd-flex justify-content-center' : ''}`}>
                                                        <Star
                                                            value={testimonial.rate}
                                                            width={45}
                                                            height={40}
                                                            spacing={2}
                                                        />
                                                    </div>
                                                    <p className="fw-light lh-2 my-3">
                                                        {testimonial.content}
                                                    </p>
                                                    <p className="text-gray-500 mb-0">
                                                        {testimonial.familyName}
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </Carousel.Item>
                        ))}
                    </Carousel>
                </div>
            </div>
        </section>
    )
}
